import { createId } from '@paralleldrive/cuid2';
import type { SelectedStep } from '~/server/logic/prisma/step-select';
import { opModelToSelectedOp } from '~/server/logic/steps/operation/op-model-to-seleceted-op-converter';
import type { RouterInputs } from '~/trpc-extra/api';

export function spliceInStep(steps: SelectedStep[], newStep: SelectedStep) {
  const updatedSteps = steps.map((step) =>
    step.stepOrder >= newStep.stepOrder ? { ...step, stepOrder: step.stepOrder + 1 } : step,
  );

  // Find the correct index to insert the new step
  const insertIndex = updatedSteps.findIndex((step) => step.stepOrder > newStep.stepOrder);

  // Insert the new step at the correct index
  updatedSteps.splice(insertIndex === -1 ? updatedSteps.length : insertIndex, 0, newStep);

  return updatedSteps;
}

export function getDummyStep(newStep: RouterInputs['testStep']['insert']): SelectedStep {
  const now = new Date();
  return {
    id: newStep.id ?? createId(),
    createdAt: now,
    updatedAt: now,
    stepOrder: newStep.order,
    description: newStep.description,
    operations: (newStep.operations || []).map((op, idx) => ({
      ...opModelToSelectedOp(op),
      id: op.operationId ?? `op_${now.getTime()}_${idx}`,
    })),
    testAccountId: '',
    testContentId: newStep.testContentId,
    source: 'RECORDER',
    skip: false,
    mode: newStep.mode || 'STRICT',
    autoHealConfig: null,
    omitReferenceActions: null,
  };
}
